import { Controller } from "@hotwired/stimulus";
import { NestedFormRenumber } from "../shared/nested_form_renumber";
import { NestedFormMaxNumber } from "../shared/nested_form_max_number";

// Connects to data-controller="resumin--form-duplication"
export default class extends Controller {
  // valuesには定義していないが、以下の属性を要素に設定すると、コピーはしない。
  // data-resumin--form-duplication-ignore-value=true
  static values = {
    containerId: String,
    removeClass: String,
  };

  connect() {
    NestedFormRenumber(this);
    NestedFormMaxNumber(this);
  }

  duplicate(e) {
    e.preventDefault();

    const newElement = this.element.cloneNode(true);
    const container = document.getElementById(this.containerIdValue);
    const ids = container.querySelectorAll(
      '[data-resumin--form-duplication-target="id"]'
    );
    const index = this.maxNumberFromId(ids) + 1;

    const elements = newElement.querySelectorAll("input, select, textarea");
    elements.forEach((input) => {
      // idを利用するので採番より先に実行する。
      // select要素の場合、元の要素が最初の状態から変更されてからコピーすると変更前の値の状態でコピーされてしまうため
      // 元の値を取得して、明示的に設定する。
      if (input.tagName.toLowerCase() === "select") {
        const originalValue = this._getOriginalSelectValue(input.id);
        input.value = originalValue;
      }

      this.renumber(input, index);

      // 要素自体は複製するがデータとしては新規なのでIDは空にする。
      if (input.dataset["resumin-FormDuplicationTarget"] === "id") {
        input.value = "";
      }

      // positionの値は、今の要素数+1にする。
      if (input.dataset["resumin-FormDuplicationTarget"] === "position") {
        input.value = index + 1;
      }
    });

    newElement
      .querySelectorAll("[data-resumin--form-duplication-ignore-value='true']")
      .forEach((el) => el.remove());

    const className = this.removeClassValue;
    if (className) {
      newElement
        .querySelectorAll(`.${className}`)
        .forEach((el) => el.classList.remove(className));
    }

    container.appendChild(newElement);
  }

  _getOriginalSelectValue(id) {
    const originalSelect = this.element.querySelector(`#${id}`);
    if (!originalSelect) {
      return null;
    }

    return originalSelect.value;
  }
}
